import createDataContext from "./createDataContext";

import Arches from "../images/Arches.jpg";
import AutoGlass from "../images/Auto-Glass.jpg";
import Banff from "../images/Banff.jpg";
import BigSur from "../images/Big-Sur.jpg";
import Cityscape from "../images/Cityscape.jpg";
import Downtown from "../images/Downtown.jpg";
import Government from "../images/Government-Building.jpg";
import GreenForest from "../images/Green-Forest.jpg";
import Office from "../images/Office.jpg";
import RedRock from "../images/Red-Rock.jpg";
import Yellowstone from "../images/Yellowstone.jpg";
import Yosemite from "../images/Yosemite.jpg";

const merchantBackgroundImage = (payload) => {
  if (payload.merchantBackgroundImageType?.includes("custom")) {
    return payload.merchantBackgroundImage;
  } else {
    switch (payload.merchantBackgroundImageType) {
      case "arches":
        return Arches;
        break;
      case "autoglass":
        return AutoGlass;
        break;
      case "banff":
        return Banff;
        break;
      case "bigSur":
        return BigSur;
        break;
      case "cityscape":
        return Cityscape;
        break;
      case "downtown":
        return Downtown;
        break;
      case "government":
        return Government;
        break;
      case "forest":
        return GreenForest;
        break;
      case "office":
        return Office;
        break;
      case "redRock":
        return RedRock;
        break;
      case "yellowstone":
        return Yellowstone;
        break;
      case "yosemite":
        return Yosemite;
        break;
      default:
        return null;
        break;
    }
  }
};

let axios = require("axios");
let qs = require("qs");
const reducer = (state, action) => {
  switch (action.type) {
    case "hydrate_portal":
      return {
        ...state,
        ...action.payload,
        portalHydrated: true,
        loading: false,
        merchantBackgroundImage: merchantBackgroundImage(action.payload),

        glcode:
          Object.keys(action.payload.glcode_list).length === 0 ? false : true,
        current_glcode: action.payload.current_glcode[1]
          ? action.payload.current_glcode[1]
          : 9999999,
      };
    case "op_error":
      return {
        ...state,
        opError: true,
        loading: false,
      };
    case "set_external_provider_data":
      return {
        ...state,
        externalProviderData: action.payload.externalData,
        chartData: action.payload.chartData,
      };
    default:
      return state;
  }
};

const hydratePortal =
  (dispatch) =>
  async ({ op, glcode, getSession, history, queryString }) => {
    let merchant = null;

    if (sessionStorage.getItem("merchant")) {
      merchant = JSON.parse(sessionStorage.getItem("merchant"));
    }

    // console.log("op", op, glcode);

    if (!op) {
      console.log("OPID does not exist in url param hydratePortal", op);
      console.log("op error");
      dispatch({ type: "op_error", payload: null });
      return;
    }

    try {
      const hydratePortalResponse = await axios({
        method: "post",
        data: qs.stringify({
          method: "hydratePortal",
          opID: op,
          glcode,
        }),
        withCredentials: true,
      });

      console.log("HYDRATE PORTAL RESPONSE", hydratePortalResponse);

      if (hydratePortalResponse.data.status === 1) {
        dispatch({
          type: "hydrate_portal",
          payload: hydratePortalResponse.data,
        });

        sessionStorage.setItem(
          "merchant",
          JSON.stringify({
            ...hydratePortalResponse.data,
          })
        );
        getSession({ history, op, queryString });
      } else {
        sessionStorage.removeItem("merchant");
        dispatch({
          type: "op_error",
          payload: null,
        });
      }
    } catch (error) {
      console.log("the error came this way", error);
    }
  };

const reHydratePortal =
  (dispatch) =>
  async ({ op, queryString }) => {
    let merchant = null;

    if (sessionStorage.getItem("merchant")) {
      merchant = JSON.parse(sessionStorage.getItem("merchant"));
    }

    let opID = null;

    if (op) {
      console.log("OPID exists in url param rehyrdatePortal");
      console.log("OPID from session storage rehydratePortal", op);
      opID = op;
    } else {
    }

    if (opID === "") {
      dispatch({ type: "op_error", payload: null });
      return;
    }

    try {
      const hydratePortalResponse = await axios({
        method: "post",
        data: qs.stringify({
          method: "reHydratePortal",
        }),
        withCredentials: true,
      });

      console.log("REHYDRATE PORTAL RESPONSE", hydratePortalResponse);

      if (hydratePortalResponse.data.status === 1) {
        dispatch({
          type: "hydrate_portal",
          payload: hydratePortalResponse.data,
        });

        console.log("REHYDRATE PORTAL OPID", hydratePortalResponse.data.opID);

        sessionStorage.setItem(
          "merchant",
          JSON.stringify({
            ...hydratePortalResponse.data,
          })
        );

				// try {
				// 	const response = await axios({
				// 		method: 'post',
				// 		data: qs.stringify({
				// 			method: 'getExternalProviderTransactions',
				// 		}),
				// 		withCredentials: true,
				// 	});

				// 	console.log(
				// 		'getExternalProviderTransactions',
				// 		response.data.results.activities.Electric[
				// 			Object.keys(response.data.results)[0]
				// 		]
				// 	);

				// 	const chartData =
				// 		response.data.results.activities.Electric[
				// 			Object.keys(response.data.results)[0]
				// 		];

				// 	dispatch({
				// 		type: 'set_external_provider_data',
				// 		payload: {
				// 			externalData: response.data.results,
				// 			chartData,
				// 		},
				// 	});
				// } catch {
				// 	console.log('Error getting external provider transactions');
				// }
			} else {
				sessionStorage.removeItem('merchant');
				dispatch({
					type: 'op_error',
					payload: null,
				});
			}
		} catch {
			console.log('Error ReHydrating portal');
		}
	};

const getExternalProviderTransactions = (dispatch) => async () => {
	try {
		const response = await axios({
			method: 'post',
			data: qs.stringify({
				method: 'getExternalProviderTransactions',
			}),
			withCredentials: true,
		});

		console.log(
			'getExternalProviderTransactions',
			response.data.results.activities.Electric[
				Object.keys(response.data.results)[0]
			]
		);

		const chartData =
			response.data.results.activities.Electric[
				Object.keys(response.data.results)[0]
			];

		dispatch({
			type: 'set_external_provider_data',
			payload: {
				externalData: response.data.results,
				chartData,
			},
		});
	} catch {
		console.log('Error getting external provider transactions');
	}
};

export const { Provider, Context } = createDataContext(
	reducer,
	{
		hydratePortal,
		reHydratePortal,
		getExternalProviderTransactions,
	},
	{
		merchantID: null,
		merchantName: null,
		merchantLogoURL: sessionStorage.getItem('merchant')
			? JSON.parse(sessionStorage.getItem('merchant')).merchantLogoURL
			: null,
    verticalMarketLogo : '',
		merchantBackgroundImage: null,
		merchantBackgroundImageType: null,
		merchantAddress: '',
		merchantAddress2: '',
		merchantCity: '',
		merchantGroup: '',
		merchantPhone: '',
		merchantState: '',
		merchantZip: '',
		loginMessage: '',
		fields: {},
		loading: true,
		opError: false,
    dealerMerchant: false,
		portalHydrated: false,
		allowPartialPayment: false,
		showSummarySidebar: true,
		allowAutoPay: true,
		ccEnable : true,
		achEnable : true,
		barColor: '#004786',
		buttonColor: '#84BD00',
		enable_einvoicing: false,
		invoice_interface: '',
		glcode: null,
		chartData: {
			electric: {
				labels: ['Mar 2021'],
				datasets: [
					{
						data: [0],
						backgroundColor: ['#EE9C03'],
					},
				],
			},
			water: {
				labels: [],
				datasets: [
					{
						data: [],
						backgroundColor: ['#EE9C03'],
					},
				],
			},
		},
		externalProviderData: {},
		externalProvider : ''
	}
);
